import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const VIEW_PERMISSIONS = [PERMISSIONS.SPNVIEW];

const EDIT_PERMISSIONS = [PERMISSIONS.SPNEDIT];

const APPROVE_PERMISSIONS = [PERMISSIONS.ROLE_SPN_APPROVE_DIST, PERMISSIONS.ROLE_SPN_APPROVE_STATE];

export const STRUCTURE_PLAN_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
  [ACCESS_LEVELS.EDIT]: EDIT_PERMISSIONS,
  [ACCESS_LEVELS.APPROVE]: APPROVE_PERMISSIONS,
};
